import { render, staticRenderFns } from "./GridTransferDock.vue?vue&type=template&id=33871492&scoped=true"
import script from "./GridTransferDock.vue?vue&type=script&lang=js"
export * from "./GridTransferDock.vue?vue&type=script&lang=js"
import style0 from "./GridTransferDock.vue?vue&type=style&index=0&id=33871492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33871492",
  null
  
)

export default component.exports